import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { Link } from '@mui/material'

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/billing-plan'
import Menu from '/components/billing/nav-menu'
import Plan from '/components/billing/plan'

const BillingTariff = () => {

  const navigate = useNavigate()
  const { user } = useContext(AppContext)
  
  if (user?.permissions.client_admin) return (
    <PageWrapper title="Billing - Subscription Plan" HelpText={HelpText} heading={<>Payment Plan<span className='ml-10 text-sm'> (See <Link href="https://www.smartix.uk/pricing" target="_docs" className="link">Payment Plans</Link> for more details)</span></>} menu={<Menu />}>
      <div className='flex flex-row w-full'>
        <Plan />
      </div>      
    </PageWrapper>
  )
  else navigate("/")
}

export default BillingTariff